import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Flex } from 'reflexbox'
import CSSModules from 'react-css-modules'

import SliderValidationTooltip from 'components/custom/SliderValidationTooltip/index'
import styles from './styles.scss'

const FormTitle = (props) => {
  const {
    title,
    isRisk,
    children,
  } = props

  return (
    <Flex>
      <Flex styleName='title'>
        <span>{ title }</span>
        <SliderValidationTooltip
          isRisk={isRisk}
        />
      </Flex>
      { children }
    </Flex>
  )
}

FormTitle.propTypes = {
  title: PropTypes.string.isRequired,
}

export default CSSModules(FormTitle, styles)
